import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=45ba291e"
import script from "./KButton.vue?vue&type=script&lang=js"
export * from "./KButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports